// extracted by mini-css-extract-plugin
export default {"modalProfile":"Modal_modalProfile__w7iT9","modalDirectory":"Modal_modalDirectory__QqbkY"};